import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./printing-solutions.css";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".panel-section").forEach((panel) => {
    const cards = panel.querySelectorAll(".panel-card");
    const cardTrack = panel.querySelector(".panel-card-track");
    const cardsOffset = 75;
    const totalDistance = 100 * (cards.length - 1);
    const centerAdjustment = -5;
    const backgroundImages = panel.querySelector(".panel-background-images");
    let currentActiveIndex = -1;
    let enterTimeout;

    if (!cards.length) {
      return;
    }

    const updateBackgroundImage = () => {
      if (!backgroundImages || backgroundImages.classList.contains("as-single")) {
        return;
      }

      backgroundImages.querySelector(".is-active")?.classList.remove("is-active");
      backgroundImages.children[currentActiveIndex + 1]?.classList.add("is-active");
    };

    gsap.to(backgroundImages, {
      y: "-10%",
      scrollTrigger: {
        trigger: panel,
        start: "top bottom",
        end: "top top",
        markers: false,
        scrub: 2,
      },
    });

    gsap.set(cards, {
      xPercent: cardsOffset,
      force3D: true,
      backfaceVisibility: "hidden",
    });

    gsap
      .timeline({
        paused: true,
        scrollTrigger: {
          trigger: panel,
          anticipatePin: true,
          pin: true,
          scrub: 2,
          preventOverlaps: true,
          start: () => {
            const offset = getComputedStyle(document.documentElement).getPropertyValue("--site-header-stuck-height");

            return `top ${offset}`;
          },
          end: () => "+=" + cardTrack.offsetWidth,
          markers: false,
          onUpdate: (self) => {
            const scrollProgress = self.progress;
            const currentPosition = cardsOffset - scrollProgress * (totalDistance + cardsOffset);
            const adjustedPosition = currentPosition + centerAdjustment;
            let activeIndex = -1;

            if (scrollProgress > 0.05) {
              activeIndex = Math.round(Math.abs(adjustedPosition) / 100);
            }

            if (activeIndex !== currentActiveIndex) {
              currentActiveIndex = activeIndex;

              updateBackgroundImage();
            }
          },
          onEnter: () => {
            if (enterTimeout) {
              clearTimeout(enterTimeout);
            }

            enterTimeout = setTimeout(() => {
              panel.classList.add("is-active");
            }, 500);
          },
          onEnterBack: () => {
            if (enterTimeout) {
              clearTimeout(enterTimeout);
            }

            enterTimeout = setTimeout(() => {
              panel.classList.add("is-active");
            }, 500);
          },
          onLeave: () => {
            if (enterTimeout) {
              clearTimeout(enterTimeout);
            }

            panel.classList.remove("is-active");
          },
          onLeaveBack: () => {
            if (enterTimeout) {
              clearTimeout(enterTimeout);
            }

            panel.classList.remove("is-active");
          },
        },
      })
      .to(cards, {
        xPercent: -totalDistance,
        ease: "none",
      });
  });
});
